'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.setting.service
 * @description
 * # setting.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('settingService', function(BaseService, errorService, eventsService) {

    var service = new BaseService();
    var settings = [];

    service.getRoleClaimMatrix = getRoleClaimMatrix;
    service.updateRoleClaimMatrix = updateRoleClaimMatrix;

    function getRoleClaimMatrix() {
      return service.http.get(service.baseUrl + '/claims/matrix')
      .then(handleSuccess)
      .catch(handleError);
    }

    function updateRoleClaimMatrix(matrix) {
      return service.http.post(service.baseUrl + '/claims/matrix', matrix)
      .then(handleSuccess)
      .catch(handleError);
    }

    function handleSuccess(response) {
     return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }

    return service;
  });
